import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DataTable,
  Field,
  DateTimeField,
  CurrencyField,
} from '../../commons/DataTable';
import CustomerNameFieldAdmin from '../../commons/DataTable/CustomerNameFieldAdmin';

function PanoramicaInsuranceTabel({ data, onFilter, query = {}, total = 0 }) {
  const [t] = useTranslation('COMMON');
  const { offset, limit } = query;

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('NO_DATA')}
    >
      <Field
        title="Nome Fornitore"
        source="supplier.businessName"
        className="text-left"
      />
      <Field title="Codice polizza" source="policy_code" />
      <Field title="Etichetta polizza" source="insurance_code" />
      <Field title="Referente" source="admin.businessName" />
      <Field title="Codice fiscale referente" source="admin.taxCode" />
      <Field title="Fornitore" source="supplier.businessName" />
      <Field title="Tipo agenzia" source="agencyType" />
      <CustomerNameFieldAdmin title="Cliente" source="customer.name" />
      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
      />
      <DateTimeField title="Data fine" source="end_date" format="DD/MM/YYYY" />

      <CurrencyField
        title="Premio lordo"
        source="gross"
        className="txt-table-right"
      />
      <CurrencyField
        title="Premio netto"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="ROY La Panoramica"
        source="shareToInvoice"
        className="txt-table-right"
      />
    </DataTable>
  );
}

export default PanoramicaInsuranceTabel;
